var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.039 3.02704H0.960961C0.432432 3.02704 0 3.45947 0 3.988C0 4.51653 0.432432 4.94896 0.960961 4.94896H31.039C31.5676 4.94896 32 4.51653 32 3.988C32 3.45947 31.5676 3.02704 31.039 3.02704Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1021 11.003H0.960961C0.432432 11.003 0 11.4354 0 11.964C0 12.4925 0.432432 12.9249 0.960961 12.9249H22.1021C22.6306 12.9249 23.0631 12.4925 23.0631 11.964C23.0631 11.4354 22.6306 11.003 22.1021 11.003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.039 19.0751H0.960961C0.432432 19.0751 0 19.5075 0 20.036C0 20.5646 0.432432 20.997 0.960961 20.997H31.039C31.5676 20.997 32 20.5646 32 20.036C32 19.5075 31.5676 19.0751 31.039 19.0751Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5105 27.0511H0.960961C0.432432 27.0511 0 27.4835 0 28.012C0 28.5405 0.432432 28.973 0.960961 28.973H14.5105C15.039 28.973 15.4715 28.5405 15.4715 28.012C15.4715 27.4835 15.039 27.0511 14.5105 27.0511Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.47a9f5420692ff5c0b6962624d499d4a.svg";
export { ForwardRef as ReactComponent };